import { Injectable } from '@angular/core';
import { HttpClient, HttpParams  } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { QueryRequestDto, MultiResponseDto, SingleResponseDto, RoleInfoDto, } from '@bugz-mono/shared-dtos';
import { environment } from '@bugz-mono/shared-environments'

@Injectable({
  providedIn: 'root', 
})
export class RolesApiService {

  private apiUrl= `${environment.apiUrl}/roles`;
  
  constructor(private http: HttpClient) {
  }
 
  getOne(id:number) :Observable<SingleResponseDto<RoleInfoDto>>{
    try {
      return this.http.get<SingleResponseDto<RoleInfoDto>>(`${this.apiUrl}/getOne`,{params :{id: id}});  
    } catch (error) {
      console.log(error);
      return of( {
        success:false,
        message: 'API Error',
      });
    }
  }

  
  getAll(queryOptions?: QueryRequestDto): Observable<MultiResponseDto<RoleInfoDto>> {
    let params = new HttpParams();
    if (queryOptions?.filtersJson) {
      params = params.append('filters', queryOptions.filtersJson);
    }
    if (queryOptions?.joinsJson) {
      params = params.append('joins', queryOptions.joinsJson);
    }
    if (queryOptions?.sortJson) {
      params = params.append('sort', queryOptions.sortJson);
    }
    if (queryOptions?.paginationJson) {
      params = params.append('pagination', queryOptions.paginationJson);
    }

    return this.http.get<MultiResponseDto<RoleInfoDto>>(`${this.apiUrl}/getAll`, { params});  

  }

  getList(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getList`,);  
  }

  create(dto:RoleInfoDto):Observable<MultiResponseDto<RoleInfoDto>>{
    return this.http.post<MultiResponseDto<RoleInfoDto>>(`${this.apiUrl}/create`, dto);  
  }
  update(dto:RoleInfoDto):Observable<MultiResponseDto<RoleInfoDto>>{
    return this.http.post<MultiResponseDto<RoleInfoDto>>(`${this.apiUrl}/update`, dto);  
  }
  
}